
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft3 as ObiWindShaft3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-3.js';
 
 
 

 
 export const ObiWindShaft3 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-3',
   elementClass: ObiWindShaft3Element,
   events: {
     
   }
  });
 
 